import http from "./httpService";
import { getApiUrl } from "../config";
import { AxiosRequestConfig } from "axios";
import { downloadBlob } from "./download.service";

const apiEndpoint = getApiUrl() + "/forms";

function formUrl(id) {
  return `${apiEndpoint}/${id}`;
}

function submitForm(form) {
  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  return http.post(apiEndpoint, form, config);
}

function updatePdfFileForm(formId, form) {
  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  return http.put(`${apiEndpoint}/updatePdfFile/${formId}`, form, config);
}

function saveForm(formId, form) {

  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  return http.put(`${getApiUrl() + "/forms"}/${formId}`, form, config);
}
interface StatusInscricao {
  id: string;
  status: 1 | 2 | 3;
  statusUpdateDescription: string;
}


function updateInscricaoBolsista(id, data) {
  const body = { ...data, id };
  delete body.formId;
  return http.post(`${getApiUrl()}/inscricoes`, body);
}

function createInscricaoBolsista(formData) {
  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };

  return http.post(`${getApiUrl()}/inscricoes`, formData, config);
}

const getFormValidations = async (form: Form): Promise<string[]> => {
  let response = await http.post<string[]>(`${getApiUrl()}/forms/validate`, form);
  return response.data;
}

function getBolsistaForms() {
  return http.get(`${getApiUrl()}/inscricoes`);
}

function getForms() {
  return http.get(apiEndpoint);
}

function updateStatus(data: StatusInscricao) {
  return http.post(`${apiEndpoint}/updateStatus`, data);
}

function getForm(formId) {
  return http.get<Form>(formUrl(formId));
}

async function getDownloadTermo(id): Promise<Blob> {
  const config: AxiosRequestConfig = {
    responseType: "blob",
  };

  let response = await http.get<Blob>(`${apiEndpoint}/downloadNewTerm/${id}`, config);
  return response.data;
}

const getPDFUrl = (formId: string) => `${apiEndpoint}/downloadPDF/${formId}`;
async function fetchPDF(id) {
  const config: AxiosRequestConfig = {
    responseType: "blob",
  };
  let response = await http.get<Blob>(`${apiEndpoint}/downloadPDF/${id}`, config);
  return response.data;
}

async function downloadDocuments(formId: string, docName: string) {
  let termoBlob = await fetchPDF(formId)
  downloadBlob(termoBlob, docName);
}

function deleteForm(formId) {
  return http.delete(formUrl(formId));
}

export type StatusCode = 1 | 2 | 3 | 4 | 5;

export let AllowedToEmit = [1, 4];

export const IsAllowedToEmit = (status: number) => AllowedToEmit.includes(status);

export const FormStatusList = [
  { name: "Sem status", value: undefined },
  { name: "Aprovado", value: 1 },
  { name: "Rejeitado", value: 2 },
  { name: "Pendente Coordenador", value: 3 },
  { name: "Finalizado", value: 4 },
  { name: "Pendente Administrador", value: 5 }



];
export const StatusCodeToString = (status: StatusCode) => {
  if (!status) return "Sem status";
  switch (status) {
    case 1: return "Aprovado"
    case 2: return "Rejeitado";
    case 3: return "Pendente Coordenador";
    case 4: return "Finalizado";
    case 5: return "Pendente Administrador";


    default: return "Sem status";
  }
}


const exportObject = {
  submitForm,
  formUrl,
  getForms,
  getForm,
  getDownloadTermo,
  fetchPDF: fetchPDF,
  saveForm,
  deleteForm,
  updatePdfFileForm,
  getBolsistaForms,
  updateInscricaoBolsista,
  createInscricaoBolsista,
  updateStatus,
  getFormValidations,
  downloadDocuments,
  getPDFUrl,
  AllowedToEmit,
  IsAllowedToEmit
};

export default exportObject;
